import React from 'react';
import { EyeIcon, CheckCircleIcon, ClockIcon, BookOpenIcon, CalendarIcon, BadgeCheck, CheckCircle } from 'lucide-react';
const HeaderGlpAdv1 = () => {
  return <header className="bg-white" style={{
    fontFamily: 'Georgia, Cambria, "Times New Roman", serif'
  }} data-id="element-5921">
      {/* Top black bar */}
      <div className="bg-black h-3 w-full" data-id="element-5922"></div>

      {/* Masthead section */}
      <div className="border-b border-gray-800 px-4 sm:px-6 py-4 sm:py-6" data-id="element-5923">
        <div className="text-center pb-3 sm:pb-4 mb-3 sm:mb-4" data-id="element-5924">
          <h2 className="font-serif text-2xl sm:text-3xl font-bold tracking-tight text-gray-900" data-id="element-5925">
            TRADITIONAL MEDPUB
          </h2>
          <div className="text-xs uppercase tracking-widest text-gray-500 mt-2 font-medium" data-id="element-5926">
            INDEPENDENT HEALTH INVESTIGATIONS SINCE 1982
          </div>
        </div>

        <div className="flex flex-col sm:grid sm:grid-cols-3 text-xs text-gray-600 border-b border-gray-300 pb-2 gap-1 sm:gap-0" data-id="element-5927">
          <div className="text-left" data-id="element-5928">VOL. 128, NO. 43</div>
          <div className="text-left sm:text-center" data-id="element-5929">
            {(() => {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            return yesterday.toLocaleDateString('en-US', {
              weekday: 'long',
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            }).toUpperCase();
          })()}
          </div>
          <div className="text-left sm:text-right" data-id="element-5930">
            HEALTH & WELLNESS SECTION
          </div>
        </div>
      </div>

      {/* Article header */}
      <div className="px-4 sm:px-6 py-6 border-b border-gray-200" data-id="element-5931">
        <div className="max-w-4xl mx-auto" data-id="element-5932">
          <div className="uppercase text-xs tracking-wider text-gray-500 font-medium border-b border-gray-200 pb-2 mb-4" data-id="element-5933">
            INVESTIGATIVE REPORT
          </div>

          <h1 className="font-serif text-2xl sm:text-4xl font-bold text-gray-900 leading-tight mb-6" data-id="element-5934">
            How To Take Any GLP-1 Drug Without The Nightmares, Anxiety, Or
            Emotional Numbness That Makes You Wonder If It's Worth It
          </h1>

          <div className="my-6" data-id="element-5935">
            <img src="https://cdn.magicpatterns.com/uploads/1rggcG23avR6QSjaCBdvck/Untitled_(1500_x_1000_px)_(1200_x_1000_px)_(1600_x_1200_px)_(3).png" alt="Before and after transformation" className="w-full rounded-lg shadow-md" data-id="element-5936" />
          </div>

          <p className="text-lg font-medium text-gray-700 mb-6 leading-relaxed border-l-4 border-gray-800 pl-4" data-id="element-5937">
            A nurse practitioner's discovery—backed by research from Uppsala
            University that saved my sister and is now helping over 36,700
            people lose weight without losing themselves.
          </p>

          {/* Author Byline */}
          <div className="flex items-center gap-3 mb-6 pb-5 border-b border-gray-200" data-id="element-5938">
            <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0 bg-gray-200" data-id="element-5939">
              <img src="https://cdn.magicpatterns.com/uploads/4PvNLd6RsPB1kVDZBzePem/c844778a-6484-4fd0-ade7-865535abf330.png" alt="Journalist" className="w-full h-full object-cover" data-id="element-5940" />
            </div>
            <div className="flex-1" data-id="element-5941">
              <div className="flex items-center gap-1 mb-1" data-id="element-5942">
                <span className="text-sm font-medium text-gray-900" data-id="element-5943">
                  Written by Sarah Mitchell
                </span>
                <BadgeCheck className="h-4 w-4 text-blue-600" data-id="element-5944" />
              </div>
              <div className="text-xs text-gray-600 mb-1" data-id="element-5945">
                Investigative Health Journalist • 17 Yrs Exp
              </div>
              <div className="flex items-center gap-3 text-xs text-gray-500" data-id="element-5946">
                <div className="flex items-center gap-1" data-id="element-5947">
                  <ClockIcon className="h-3 w-3" data-id="element-5948" />
                  <span data-id="element-5949">14 min read</span>
                </div>
                <div className="flex items-center gap-1" data-id="element-5950">
                  <EyeIcon className="h-3 w-3" data-id="element-5951" />
                  <span data-id="element-5952">31,542 views</span>
                </div>
              </div>
            </div>
          </div>

          <p className="mb-5 text-base leading-relaxed text-gray-700" data-id="element-5953">
            If you're on Semaglutide or Tirzepatide—and you're noticing things
            like:
          </p>

          <div className="space-y-2 mb-6" data-id="element-5954">
            <div className="flex items-start gap-2" data-id="element-5955">
              <CheckCircle className="h-5 w-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-5956" />
              <p className="text-gray-700 text-base leading-relaxed" data-id="element-5957">
                Anxiety that comes from nowhere and won't leave
              </p>
            </div>
            <div className="flex items-start gap-2" data-id="element-5958">
              <CheckCircle className="h-5 w-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-5959" />
              <p className="text-gray-700 text-base leading-relaxed" data-id="element-5960">
                A flat, numb feeling where emotions used to be
              </p>
            </div>
            <div className="flex items-start gap-2" data-id="element-5961">
              <CheckCircle className="h-5 w-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-5962" />
              <p className="text-gray-700 text-base leading-relaxed" data-id="element-5963">
                Vivid nightmares that jolt you awake
              </p>
            </div>
            <div className="flex items-start gap-2" data-id="element-5964">
              <CheckCircle className="h-5 w-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-5965" />
              <p className="text-gray-700 text-base leading-relaxed" data-id="element-5966">
                A sense of dread you can't explain
              </p>
            </div>
            <div className="flex items-start gap-2" data-id="element-5967">
              <CheckCircle className="h-5 w-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-5968" />
              <p className="text-gray-700 text-base leading-relaxed" data-id="element-5969">
                Zero motivation to do things you used to love
              </p>
            </div>
            <div className="flex items-start gap-2" data-id="element-5970">
              <CheckCircle className="h-5 w-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-5971" />
              <p className="text-gray-700 text-base leading-relaxed" data-id="element-5972">
                Feeling disconnected from people close to you
              </p>
            </div>
          </div>

          <p className="mb-5 text-base leading-relaxed text-gray-700" data-id="element-5973">
            ...you're not imagining it. You're not alone.
          </p>

          <p className="mb-5 text-base leading-relaxed text-gray-700" data-id="element-5974">
            And it's not permanent—if you understand{' '}
            <strong data-id="element-5975">
              what's actually happening inside your body right now
            </strong>
            .
          </p>

          <p className="mb-6 text-base leading-relaxed text-gray-700" data-id="element-5976">
            In my 17 years as an investigative health journalist, I've covered
            dozens of pharmaceutical controversies. But this one hit close to
            home.
          </p>
        </div>
      </div>
    </header>;
};
export default HeaderGlpAdv1;